<template>
  <div v-if="bannerList.length > 0">
    <div id="redPacket" v-if="$store.state.appInfo.redpacket_switch == 1 && hongbashow">
      <i @click="$parent.goNav('/hongbao')" class="grab"></i>
      <img @click="changhongbashow" src="/static/image/hongbaocolse.png" />
    </div>
    <div class="appbox" v-if="appshow">
      <img class="colse" @click="appshow = false" src="/static/image/hongbaocolse.png" alt="" />
      <img class="logo" v-if="$store.state.appInfo.site_logo" :src="$store.state.appInfo.site_logo" alt="" />
      <img class="logo" v-else src="/static/image/app-logo.png" alt="" />
      <div class="testz">
        <div class="tit">{{ $store.state.appInfo.title }}app</div>
        <div class="cx">真人娱乐，体育投注，电子游艺等尽在一手掌握</div>
      </div>
      <van-button type="info" style="background: url(/static/image/btnBg.png) no-repeat; background-size: 100% 100%; font-size: 0.24rem; border: none; border-radius: 6px; height: 0.6rem" @click="$parent.goNav('/app')">立即下载</van-button>
      <!-- btnBg.png -->
    </div>
    <div style="position: relative">
      <div class="homeHeder">
        <img class="leftImg" @click="changleftshow" src="/static/image/home_muen.png" alt="" />
      </div>
      <div class="bannerWrap">
        <van-swipe class="homeSwipe" :autoplay="4500" @change="onChange">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <img class="bannerImg" :src="item.src" alt="" />
          </van-swipe-item>
          <template #indicator>
            <div class="swiper-dots">
              <div class="num">{{ current + 1 }}</div>
              <div class="sign">/</div>
              <div class="num">{{ bannerList.length }}</div>
            </div>
          </template>
        </van-swipe>
      </div>
    </div>

    <!-- 公告 -->
    <div style="background-color: #f7f8fa; padding: 6px 0 0" v-if="homenoticelis.length > 0">
      <div class="gonggao">
        <img style="width: 20px" src="/static/image/home_notice.66939586521463adbe87e2a72aa8ecad.png" alt="" />
        <div style="flex: 1">
          <van-notice-bar color="#8a1a34" background="#f7f8fa" scrollable
            ><span v-for="(item, index) in homenoticelis" @click="openGogao(item)" :key="index">{{ item }}</span></van-notice-bar
          >
        </div>
        <img @click="$parent.goNav('/message')" style="width: 68px" src="/static/image/home_hotsports.718f002d63ddbf2c3902907f2226a28b.png" alt="" />
      </div>
    </div>
    <!-- 公告 -->
    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="goInfo = null"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <img src="/static/image/hongbaocolse.png" @click="goInfo = null" style="position: absolute; top: 5px; right: 13px; width: 0.7rem" alt="" />

        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}

          <van-button type="info" style="margin: 0 auto; margin-top: 20px; width: 120px; border-radius: 10px; height: 35px" @click="$parent.goNav('/message')">更多公告</van-button>
        </div>
      </div>
    </div>
    <!-- 用户信息栏 -->
    <div class="xiding">
      <div class="caosuo">
        <div class="lefsg" v-if="$store.state.token">
          <div class="name">{{ $store.state.userInfo.username }}</div>
          <div class="mey"><span>￥</span>{{ $store.state.userInfo.balance }}</div>
        </div>
        <div v-else class="lefsg" @click="$parent.goNav('/login')">
          <div class="name">未登录</div>
          <div class="mey">登录后查看</div>
        </div>
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')">
            <img src="/static/image/nav/deposit.png" alt="" />
            存款
          </div>
          <div class="lisImg" @click="$parent.goNav('/transfer')">
            <img src="/static/image/nav/transfer.png" alt="" />
            转账
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')">
            <img src="/static/image/nav/withdraw.png" alt="" />
            取款
          </div>
          <div class="lisImg" @click="$parent.goNav('/vip')">
            <img src="/static/image/nav/vip.png" alt="" />
            VIP
          </div>
        </div>
      </div>
    </div>
    <!-- 快捷入口 -->
    <div class="quickEntry">
      <div class="qeItem" @click="$parent.goNav('/applyagent')">
        <img src="/static/image/nav/share.png" alt="" />
        <span>分享赚钱</span>
      </div>
      <div class="qeItem" @click="$parent.goNav('/activity')">
        <img src="/static/image/nav/promo.png" alt="" />
        <span>优惠活动</span>
      </div>
      <div class="qeItem" @click="$parent.goNav('/fanshui')">
        <img src="/static/image/nav/rebate.png" alt="" />
        <span>返水返利</span>
      </div>
      <div class="qeItem" @click="$parent.goNav('/message')">
        <img src="/static/image/nav/msg.png" alt="" />
        <span>消息公告</span>
      </div>
    </div>
    <!-- 我的钱包（转账钱包：中心/游戏账户 + 一键回收） -->
    <div class="walletPanel" v-if="$store.state.token">
      <div class="wpBox">
        <div class="wpCell">
          <span class="wpLabel">中心账户</span>
          <span class="wpVal">￥{{ Number($store.state.userInfo.balance || 0).toFixed(2) }}</span>
        </div>
        <div class="wpSep"></div>
        <div class="wpCell">
          <span class="wpLabel">游戏账户</span>
          <span class="wpVal">￥{{ Number(gameTotal).toFixed(2) }}</span>
        </div>
      </div>
      <div class="wpOps">
        <span class="wpRefresh" :class="{ spin: wpLoading }" @click="refreshWallet">↻</span>
        <div class="wpRecover" @click="recoverAll">一键回收</div>
      </div>
    </div>
    <!-- 热门区域 -->
    <div class="hotZone" v-if="hotList.length > 0">
      <div class="hotHead"><span class="hotDot"></span>热门游戏</div>
      <div class="hotGrid">
        <div class="hotItem" v-for="(item, index) in hotList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, item.gametype)">
          <img :src="item.gamepic" alt="" />
          <p>{{ item.gamename }}</p>
        </div>
      </div>
    </div>
    <!-- 游戏栏 -->
    <div class="gameBoxs">
      <div class="lfst">
        <div v-for="(c, ci) in categories" :key="ci" :class="activeCate == c.key ? 'ls active' : 'ls'" @click="changGameType(c.key)">
          <span class="lsIco" v-html="catIcon(c.key)"></span>
          <span class="lsLabel">{{ c.label }}</span>
        </div>
      </div>
      <div class="rigts vCards">
        <!-- 统一厂商卡：品牌美术图 + 官方 XH LOGO + 名称 -->
        <div class="vCard" v-for="(item, index) in currentList" :key="index" @click="openVendor(item)">
          <span class="vCardGlow" :class="'vg_' + activeCate"></span>
          <img class="vCardArt" :src="vendorArt(item, index)" alt="" />
          <span class="vCardLogoWrap">
            <img class="vCardLogo" :src="xhLogo(item.platform_name)" @error="onLogoErr($event, item)" alt="" />
          </span>
          <span class="vCardName">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- 找到我们（防失联入口） -->
    <div class="findUs" @click="$parent.goNav('/findus')">
      <span class="findUsIco">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
      </span>
      <div class="findUsMain">
        <span class="findUsTxt">找到我们</span>
        <span class="findUsSub">多线路收藏 · 永不失联</span>
      </div>
      <span class="findUsArrow"></span>
    </div>

    <!-- 服务保障 -->
    <div class="guardZone">
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg></span>
        <p>极速存取</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg></span>
        <p>安全加密</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg></span>
        <p>隐私保护</p>
      </div>
      <div class="guardItem">
        <span class="guardIco"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-3v-8h3a2 2 0 0 1 2 2zM3 19a2 2 0 0 0 2 2h3v-8H5a2 2 0 0 0-2 2z"></path></svg></span>
        <p>7×24客服</p>
      </div>
    </div>

    <!-- 牌照合规 -->
    <div class="licenseZone">
      <div class="licTitle">牌照合规</div>
      <div class="licLogos">
        <img v-for="(p, i) in licenseLogos" :key="i" :src="xhLogo(p)" @error="onLogoHide($event)" alt="" />
      </div>
      <div class="licBadges">
        <div class="licBadge"><span class="lbCode">MO</span><div class="lbTxt"><b>澳门政府授权</b><i>MACAU AUTHORIZATION</i></div></div>
        <div class="licBadge"><span class="lbCode">MGA</span><div class="lbTxt"><b>马耳他 MGA 认证</b><i>MGA LICENSE</i></div></div>
        <div class="licBadge"><span class="lbCode">GB</span><div class="lbTxt"><b>英国 GC 监管</b><i>UK GAMBLING</i></div></div>
      </div>
      <p class="licCopy">Copyright © {{ $store.state.appInfo.title }} 版权所有</p>
    </div>

    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="$store.state.appInfo.index_modal == 1 && tanshow">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="changtanshow"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="changtanshow" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {
      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      activeCate: 'concise',
      hotList: [],
      categories: [
        { key: 'concise', label: '电子' },
        { key: 'joker', label: '棋牌' },
        { key: 'fishing', label: '捕鱼' },
        { key: 'realbet', label: '真人' },
        { key: 'sport', label: '体育' },
        { key: 'gaming', label: '电竞' },
      ],
      // 使用宽横幅美术图卡的分类
      bannerCates: ['concise', 'fishing', 'joker'],
      // 厂商美术图映射：厂商专属图按 platform_name 精确对应；数字类（体育/捕鱼/棋牌）按显示顺序取
      artMap: {
        concise_PPS: 'e_pp',
        concise_PGS: 'e_pg',
        concise_CQ9S: 'e_cq9',
        concise_JDBS: 'e_jdb',
        concise_JILIS: 'e_mg',
        concise_FCS: 'e_db',
        concise_WG: 'e_fg',
        realbet_AGS: 'live_ag',
        gaming_IM: 'esport_1',
      },
      artPool: { sport: 5, fishing: 9, joker: 6 },
      // 全部厂商统一用「品牌渐变底 + XH logo」合成横幅（运营反馈美术图偏糊，弃用）。
      // 若日后有更好的正式美术图，把 {cate}_{platform} 加回此表并放 banner_{cate}_{platform}.avif 即可自动切换。
      bannerSet: {},
      // 牌照合规展示的厂商 logo（取 XH gamelogo，加载失败自动隐藏）
      licenseLogos: ['PPS', 'PGS', 'CQ9S', 'JDBS', 'WG', 'AG', 'BBBY', 'BGBY', 'MT'],
      tanshow: true,
      appshow: true,
      goInfo: null,
      // 我的钱包（转账钱包）：游戏账户合计 + 刷新态
      gameTotal: 0,
      wpLoading: false,
    };
  },
  computed: {
    currentList() {
      return this.$store.state[this.activeCate + 'List'] || [];
    },
    isBannerCate() {
      return this.bannerCates.indexOf(this.activeCate) > -1;
    },
  },
  created() {
    let that = this;
    that.getBanList();
    that.homenotice(); //获取公告
    that.getHotGames(); //获取热门子游戏
    if (that.$store.state.token) that.loadWallet(); //钱包板块：游戏账户合计
  },
  methods: {
    getHotGames() {
      let that = this;
      that.$apiFun.get('/api/hotGames', {}).then(res => {
        if (res.code == 200) {
          that.hotList = res.data || [];
        }
      });
    },
    // 钱包板块：汇总各厂商游戏账户余额（本地镜像，快速展示；一键回收时以星汇实时为准）
    loadWallet() {
      let that = this;
      if (!that.$store.state.token) return;
      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code == 200) {
            let sum = 0;
            (res.data || []).forEach(v => {
              sum += Number(v.balance) || 0;
            });
            that.gameTotal = sum;
          }
        })
        .catch(() => {});
    },
    // 点刷新/回收后：走 refreshusermoney（内部 allusersbalance 一次批量查星汇实时余额），拿准确的游戏账户总额 + 中心余额
    refreshWallet() {
      let that = this;
      that.wpLoading = true;
      that.$apiFun
        .post('/api/refreshusermoney', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            that.gameTotal = Number(res.data.gameblance) || 0; // 实时：星汇批量返回的全厂商合计
            let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.wpLoading = false;
        })
        .catch(() => {
          that.wpLoading = false;
        });
    },
    // 一键回收：把所有厂商游戏账户余额收回中心钱包（后端逐厂商查星汇实时余额下分）
    recoverAll() {
      let that = this;
      if (!that.$store.state.token) {
        that.$parent.goNav('/login');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.hideLoading();
          that.$parent.showTost(res.code == 200 ? 1 : 0, res.message || '');
          that.refreshWallet();
        })
        .catch(() => {
          that.$parent.hideLoading();
          that.$parent.showTost(0, '回收失败，请重试');
        });
    },
    openVendor(item) {
      this.$parent.goNav(`/gamelist?platform=${item.platform_name}&cate=${item.category_id}&title=${encodeURIComponent(item.name)}`);
    },
    vendorImg(item) {
      return item.mobile_img || item.api_logo_img || item.app_img || '';
    },
    hasArt(item) {
      return !!this.bannerSet[item.category_id + '_' + item.platform_name];
    },
    bannerArt(item) {
      return '/static/vendor/banner_' + item.category_id + '_' + item.platform_name + '.avif';
    },
    xhLogo(code) {
      return 'https://alicdn.xh-img.com/uploads/images/gamelogo/' + code + 'LOGO.webp';
    },
    // 厂商美术图：先按 category+platform 精确匹配，数字类按显示顺序循环取，其余兜底
    vendorArt(item, idx) {
      var base = '/static/vendorart/';
      var key = item.category_id + '_' + item.platform_name;
      if (this.artMap[key]) return base + this.artMap[key] + '.webp';
      var pf = { sport: 'sport_', fishing: 'fish_', joker: 'card_' }[item.category_id];
      if (pf) {
        var n = this.artPool[item.category_id];
        return base + pf + ((idx % n) + 1) + '.webp';
      }
      if (item.category_id === 'realbet') return base + 'live_ag.webp';
      if (item.category_id === 'gaming') return base + 'esport_1.webp';
      return base + 'e_bbin.webp';
    },
    onLogoErr(e, item) {
      let el = e.target;
      if (el.dataset.fb) return;
      el.dataset.fb = '1';
      el.src = this.vendorImg(item);
    },
    onLogoHide(e) {
      // 牌照合规 logo 加载失败：直接隐藏，避免破图
      e.target.style.display = 'none';
    },
    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.activeCate = type;
    },
    // 侧边栏分类图标（实心质感字形，evenodd 挖空 → 金底/白底两态都清晰，currentColor 跟随激活态）
    catIcon(key) {
      var s = '<svg width="27" height="27" viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">';
      var e = '</svg>';
      var map = {
        // 电子：游戏手柄（十字键 + 双按钮挖空）
        concise:
          '<path d="M7.2 6.2h9.6a5.6 5.6 0 0 1 5.5 6.6l-.57 3.1a2.85 2.85 0 0 1-5.24.86l-1.03-1.63a1.1 1.1 0 0 0-.93-.51H9.48a1.1 1.1 0 0 0-.93.51l-1.03 1.63a2.85 2.85 0 0 1-5.24-.86l-.57-3.1A5.6 5.6 0 0 1 7.2 6.2Zm.55 3.05a.9.9 0 0 0-.9.9v.85h-.85a.9.9 0 1 0 0 1.8h.85v.85a.9.9 0 1 0 1.8 0v-.85h.85a.9.9 0 1 0 0-1.8H9.6v-.85a.9.9 0 0 0-.9-.9Zm7.55.2a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Zm2.15 2.5a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z"/>',
        // 棋牌：黑桃（实心）
        joker:
          '<path d="M12 3.2c1.75 3.05 6.7 5.4 6.7 9.35a3.35 3.35 0 0 1-5.63 2.46c.08 1.9.78 3.05 1.93 3.66v.13H8.99v-.13c1.15-.61 1.85-1.76 1.93-3.66A3.35 3.35 0 0 1 5.3 12.55C5.3 8.6 10.25 6.25 12 3.2Z"/>',
        // 捕鱼：鱼（尾鳍 + 眼睛挖空）
        fishing:
          '<path d="M2.4 12c2.6-4.05 6.7-6.1 11.15-6.1 1.05 0 2.08.13 3.06.37l2.42-2.3a.72.72 0 0 1 1.22.52v3.2c.73.85 1.15 1.9 1.15 3.09s-.42 2.24-1.15 3.09v3.2a.72.72 0 0 1-1.22.52l-2.42-2.3c-.98.24-2.01.37-3.06.37C9.1 18.05 5 16 2.4 12Zm6.55-1.35a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3Z"/>',
        // 真人：荷官/人像（实心）
        realbet:
          '<path d="M12 3.8a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4ZM12 12.5c-4.05 0-7.3 2.42-7.3 5.4 0 .78.63 1.4 1.4 1.4h11.8c.77 0 1.4-.62 1.4-1.4 0-2.98-3.25-5.4-7.3-5.4Z"/>',
        // 体育：足球（中央五边形挖空 + 环绕小块）
        sport:
          '<path d="M12 2.2A9.8 9.8 0 1 0 12 21.8 9.8 9.8 0 0 0 12 2.2Zm0 6.15 3.15 2.29-1.2 3.7h-3.9l-1.2-3.7L12 8.35Z"/>',
        // 电竞：奖杯（实心 + 双耳）
        gaming:
          '<path d="M6.6 3.4h10.8v1.2h2.9v2.5a4.2 4.2 0 0 1-4.2 4.2h-.28A5.2 5.2 0 0 1 12.9 14v2.1h2.2a1.1 1.1 0 0 1 1.1 1.1v1.05H7.8V17.2a1.1 1.1 0 0 1 1.1-1.1h2.2V14a5.2 5.2 0 0 1-2.72-2.7H8.1a4.2 4.2 0 0 1-4.2-4.2V4.6h2.7V3.4Zm0 2.6H5.3v.9a2.6 2.6 0 0 0 1.3 2.25V6Zm10.8 0v3.15A2.6 2.6 0 0 0 18.7 6.9V6h-1.3ZM7.1 19.8h9.8v1.2H7.1Z"/>',
      };
      return s + (map[key] || '') + e;
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bannerList', { type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/2d87bbdbffeb4734e5c7.css';
.domainModal_content__1nBgc {
  overflow: auto;
}
// 轮播（修“太宽”：留白 + 圆角 + 固定比例裁切）
.bannerWrap {
  padding: 10px 12px 2px;
  background: #f7f8fa;
}
.homeSwipe {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 8px 20px rgba(16, 24, 40, 0.1);
}
.bannerImg {
  display: block;
  width: 100%;
  aspect-ratio: 2.4 / 1;
  object-fit: cover;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #f7f8fa;
  color: #8a1a34;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 20px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 16px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #4e6693;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #4e6693;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #0f172a;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 12px;
    }
    .mey {
      margin-top: 3px;
      font-size: 17px;
      font-weight: 800;
      color: #c69a3f;
      letter-spacing: 0.3px;
      span {
        font-size: 11px;
        font-weight: 600;
        margin-right: 1px;
      }
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 56px;
      text-align: center;
      font-size: 12px;
      img {
        width: 42px;
        height: 42px;
        display: block;
        margin: 0 auto 2px;
      }
    }
  }
}
.xiding {
  background-color: #ffffff;
  border-bottom: 1px solid #eef0f3;
  padding: 8px 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 90;
}

// 游戏（移动端单滚动条：去掉内层固定高/overflow，整页一个滚动条；左侧分类栏 sticky 随页滚动保持可见）
.gameBoxs {
  background: #f7f8fa;
  box-sizing: border-box;
  padding: 10px 10px 4px;
  color: #0f172a;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .lfst {
    width: 50px;
    flex: 0 0 50px;
    background: #fff;
    border-radius: 16px;
    border: 1px solid #eef0f3;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
    padding: 4px 0;
    position: sticky;
    position: -webkit-sticky;
    top: 60px;
    align-self: flex-start;
    .ls {
      text-align: center;
      border-radius: 12px;
      padding: 9px 0;
      margin: 3px 4px;
      transition: all 0.15s ease;
      .lsIco {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        color: #c69a3f;
        transition: all 0.15s ease;
        svg {
          filter: drop-shadow(0 1px 1.5px rgba(150, 110, 30, 0.35));
        }
      }
      .lsLabel {
        font-size: 12px;
        display: block;
        color: #64748b;
        margin-top: 3px;
      }
    }
    .ls.active {
      background: linear-gradient(135deg, #e6c877, #c69a3f);
      box-shadow: 0 4px 10px rgba(198, 154, 63, 0.32);
      .lsIco {
        color: #fff;
        svg {
          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.28));
        }
      }
      .lsLabel {
        color: #fff;
        font-weight: 700;
      }
    }
  }
  .rigts {
    flex: 1;
    box-sizing: border-box;
    padding: 0 0 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    align-content: flex-start;
  }
}
// 热门区域
.hotZone {
  background: #f7f8fa;
  padding: 10px 12px 4px;
  .hotHead {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 800;
    color: #0f172a;
    margin-bottom: 10px;
    .hotDot {
      display: inline-block;
      width: 4px;
      height: 16px;
      border-radius: 2px;
      background: linear-gradient(180deg, #e6c877, #c69a3f);
      margin-right: 8px;
    }
  }
  .hotGrid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .hotItem {
      width: 23.5%;
      margin-bottom: 8px;
      cursor: pointer;
      img {
        width: 100%;
        border-radius: 10px;
        display: block;
      }
      p {
        font-size: 10px;
        color: #64748b;
        text-align: center;
        margin: 3px 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
// 统一厂商美术图卡：品牌美术图 + 官方 LOGO + 名称
.rigts.vCards {
  align-content: flex-start;
}
.vCard {
  width: 48.5%;
  aspect-ratio: 1 / 1.04;
  margin-top: 12px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(180deg, #1b2138 0%, #0d1224 100%);
  border: 1px solid rgba(217, 180, 91, 0.3);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08), 0 8px 20px rgba(16, 24, 40, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  &:active {
    transform: translateY(1px);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08), 0 4px 12px rgba(16, 24, 40, 0.14);
  }
  // 顶部金色高光描边
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    background: linear-gradient(180deg, rgba(230, 200, 119, 0.22), transparent 34%);
    pointer-events: none;
    z-index: 4;
  }
  .vCardGlow {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    width: 128%;
    height: 74%;
    border-radius: 50%;
    filter: blur(4px);
    opacity: 0.6;
    pointer-events: none;
    z-index: 0;
  }
  .vg_concise {
    background: radial-gradient(circle, rgba(150, 90, 220, 0.6), transparent 62%);
  }
  .vg_fishing {
    background: radial-gradient(circle, rgba(30, 175, 210, 0.58), transparent 62%);
  }
  .vg_joker {
    background: radial-gradient(circle, rgba(228, 150, 62, 0.58), transparent 62%);
  }
  .vg_realbet {
    background: radial-gradient(circle, rgba(228, 92, 128, 0.55), transparent 62%);
  }
  .vg_sport {
    background: radial-gradient(circle, rgba(56, 118, 255, 0.55), transparent 62%);
  }
  .vg_gaming {
    background: radial-gradient(circle, rgba(150, 100, 246, 0.55), transparent 62%);
  }
  .vCardArt {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    width: 100%;
    height: 80%;
    object-fit: contain;
    object-position: bottom;
    z-index: 1;
    filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.4));
  }
  .vCardLogoWrap {
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    max-width: 78%;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(9, 13, 28, 0.55);
    border: 1px solid rgba(230, 200, 119, 0.28);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vCardLogo {
    height: 18px;
    max-width: 100%;
    object-fit: contain;
    display: block;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
  }
  .vCardName {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 8px;
    z-index: 3;
    text-align: center;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.7);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 8px;
    box-sizing: border-box;
  }
}
// app下载
.appbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.8rem;
  box-sizing: border-box;
  padding-right: 15px;
  .colse {
    width: 0.4rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: 1rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.23rem;
      font-weight: 700;
    }
    .cx {
      font-size: 0.2rem;
      color: #ccc;
    }
  }
}
// 找到我们
.findUs {
  display: flex;
  align-items: center;
  margin: 16px 12px 0;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fffdf6 0%, #ffffff 62%);
  border: 1px solid #f0e6cf;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05), 0 8px 20px rgba(198, 154, 63, 0.1);
  cursor: pointer;
  .findUsIco {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 12px;
    background: linear-gradient(135deg, #e6c877, #c69a3f);
    box-shadow: 0 4px 10px rgba(198, 154, 63, 0.35);
    color: #fff;
    margin-right: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 22px;
      height: 22px;
    }
  }
  .findUsMain {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .findUsTxt {
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: 0.5px;
  }
  .findUsSub {
    font-size: 11px;
    color: #b08a3c;
    margin-top: 2px;
    letter-spacing: 0.5px;
  }
  .findUsArrow {
    width: 8px;
    height: 8px;
    border-top: 2px solid #c69a3f;
    border-right: 2px solid #c69a3f;
    transform: rotate(45deg);
    margin-left: 8px;
  }
}
// 服务保障
.guardZone {
  display: flex;
  justify-content: space-between;
  margin: 14px 12px 0;
  padding: 18px 6px;
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 6px 16px rgba(16, 24, 40, 0.06);
  .guardItem {
    flex: 1;
    text-align: center;
    .guardIco {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: linear-gradient(135deg, #fbf2d8, #fff8e8);
      border: 1px solid #f0e2bf;
      color: #c69a3f;
      box-shadow: 0 3px 8px rgba(198, 154, 63, 0.15);
      svg {
        width: 22px;
        height: 22px;
      }
    }
    p {
      font-size: 11px;
      color: #64748b;
      margin: 8px 0 0;
    }
  }
}
// 牌照合规
.licenseZone {
  margin: 14px 12px 76px;
  padding: 16px 12px 18px;
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 6px 16px rgba(16, 24, 40, 0.06);
  .licTitle {
    position: relative;
    padding-left: 12px;
    font-size: 15px;
    font-weight: 800;
    color: #0f172a;
    margin-bottom: 12px;
  }
  .licTitle::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    bottom: 2px;
    width: 4px;
    border-radius: 2px;
    background: linear-gradient(180deg, #e6c877, #c69a3f);
  }
  .licLogos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 4px;
    border-bottom: 1px solid #eef0f3;
    img {
      height: 20px;
      width: auto;
      object-fit: contain;
      margin: 0 14px 12px 0;
      filter: grayscale(25%);
    }
  }
  .licBadges {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .licBadge {
      width: 32%;
      display: flex;
      align-items: center;
      background: linear-gradient(135deg, #fdf8ec, #ffffff);
      border: 1px solid #f0e2bf;
      border-radius: 10px;
      padding: 8px 6px;
      box-sizing: border-box;
      .lbCode {
        font-size: 14px;
        font-weight: 800;
        color: #c69a3f;
        margin-right: 5px;
        white-space: nowrap;
      }
      .lbTxt {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        b {
          font-size: 10px;
          color: #334155;
          white-space: nowrap;
        }
        i {
          font-size: 7px;
          color: #94a3b8;
          font-style: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .licCopy {
    text-align: center;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 16px;
  }
}
// 快捷入口
.quickEntry {
  display: flex;
  justify-content: space-between;
  padding: 14px 14px 6px;
  background: #f7f8fa;
  .qeItem {
    flex: 1;
    text-align: center;
    cursor: pointer;
    img {
      width: 46px;
      height: 46px;
      object-fit: contain;
      display: block;
      margin: 0 auto 5px;
    }
    span {
      font-size: 12px;
      color: #475569;
    }
  }
}
.walletPanel {
  margin: 8px 14px 0;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #fffdf8, #fbf3df);
  border: 1px solid rgba(201, 154, 63, 0.4);
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(180, 140, 60, 0.12);
  .wpBox {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .wpCell {
    flex: 1;
    display: flex;
    flex-direction: column;
    .wpLabel {
      font-size: 12px;
      color: #9a7b3f;
      margin-bottom: 3px;
    }
    .wpVal {
      font-size: 17px;
      font-weight: 800;
      color: #7a1330;
    }
  }
  .wpSep {
    width: 1px;
    height: 28px;
    margin: 0 12px;
    background: rgba(201, 154, 63, 0.35);
  }
  .wpOps {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .wpRefresh {
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 18px;
      color: #9a7b3f;
      cursor: pointer;
      &.spin {
        animation: wpSpin 0.8s linear infinite;
      }
    }
    .wpRecover {
      margin-left: 6px;
      padding: 8px 14px;
      font-size: 13px;
      font-weight: 700;
      color: #fff;
      background: linear-gradient(135deg, #8a1a34, #641530);
      border-radius: 18px;
      box-shadow: 0 3px 10px rgba(122, 19, 48, 0.3);
      cursor: pointer;
    }
  }
}
@keyframes wpSpin {
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue